import { v4 as uuid } from 'uuid';
import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";

export const addNotification = createAsyncThunk("notifications/addNotitication", async (props, thunkApi) => {
    var dispatch = thunkApi.dispatch;

    let {text, type="success", closable=true, duration=null, position="bottomRight", ...other } = props;

    if (!duration)
        return ({id: uuid(), text, type, closable, duration: null, position});
    else
    {
        let id = uuid();

        window.setTimeout(() =>{
            dispatch(notificationsSlice.actions.removeNotification(id));
        }, duration*1000);

        return ({id: id, text, type, closable, duration, position});
    }    
});


const notificationsSlice = createSlice({
    name: "notifications",
    initialState: [],
    reducers:{
        removeNotification: (state, action) => state.filter(e => e.id != action.payload)
    },
    extraReducers: (builder) => {
        builder.
                addCase(addNotification.pending, (state, action) =>{
                })
                .addCase(addNotification.fulfilled, (state, action) =>{   
                    state.push(action.payload);
                    //beep(100, 600, 5).then(e => beep(100,600,5)).then(e => beep(100,600,5));
                })
                .addCase(addNotification.rejected, (state, action) =>{
                })
            }
});

export const { removeNotification } = notificationsSlice.actions;

export default notificationsSlice.reducer;
